function extractUniqueCounterparties(positions) {
  return (
    [
      ...new Set(
        (positions ?? [])
          .map(p => p.counterparty)
          // Remove empty counterparties
          .filter(s => !!s)
      ),
    ]
      // Wrap the counterparty names in objects
      .map(c => ({ name: c }))
  );
}

export { extractUniqueCounterparties };
